import { css } from '@emotion/react'
import { Button, Cell, Grid } from 'bold-ui'
import { Box } from 'components/Box'
import { Form, FormRenderProps, SubmitButton } from 'components/form'
import { MunicipioSelectField, MunicipioSelectModel } from 'components/form/field/select/MunicipioSelectField'
import { PerfilSelectField, PerfilSelectModel } from 'components/form/field/select/PerfilSelectField'
import { metaPath } from 'util/metaPath'

export interface RestricoesFormModel {
  municipiosVinculados: MunicipioSelectModel[]
  perfisVinculados: PerfilSelectModel[]
}

const path = metaPath<RestricoesFormModel>()

interface SistemasExternosRestricoesPopperFormProps {
  initialValues: RestricoesFormModel
  onSubmit(values: RestricoesFormModel): void
  onFechar(): void
  onClear(): void
}

export function SistemasExternosRestricoesPopperForm(props: Readonly<SistemasExternosRestricoesPopperFormProps>) {
  const { initialValues, onSubmit, onFechar, onClear } = props

  const renderForm = (formProps: FormRenderProps<RestricoesFormModel>) => {
    const handleClear = () => {
      formProps.form.reset({ municipiosVinculados: [], perfisVinculados: [] })
      onClear()
    }

    return (
      <Box style={styles.popperBox}>
        <Grid gapVertical={1.5} gap={1} justifyContent='flex-end'>
          <Cell size={12}>
            <MunicipioSelectField
              name={path.municipiosVinculados}
              label='Vincular municípios'
              placeholder='Todos os municípios'
              multiple
              ativo={true}
            />
          </Cell>
          <Cell size={12}>
            <PerfilSelectField
              name={path.perfisVinculados}
              label='Perfis'
              placeholder='Todos os perfis'
              mostrarQualquerLocalidade={true}
              multiple
            />
          </Cell>
          <Cell alignSelf='flex-end'>
            <Button onClick={onFechar} size='small' skin='outline' kind='normal'>
              Fechar
            </Button>
          </Cell>
          <Cell alignSelf='flex-end'>
            <Button kind='normal' size='small' onClick={handleClear}>
              Limpar campos
            </Button>
          </Cell>
          <Cell alignSelf='flex-end'>
            <SubmitButton size='small' handleSubmit={formProps.handleSubmit}>
              Aplicar
            </SubmitButton>
          </Cell>
        </Grid>
      </Box>
    )
  }

  return (
    <Form<RestricoesFormModel>
      render={renderForm}
      onSubmit={onSubmit}
      initialValues={initialValues}
      onSubmitSucceeded={onFechar}
    />
  )
}

const styles = {
  popperBox: css`
    width: 24rem;
    margin-top: 0.5rem;
  `,
}
